import React from 'react';

const SvgComponent = props => (
  <svg id="BeBold" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
    <path d="m13.805 9.306-1.541-1.79a1.321 1.321 0 0 1-.387-.935V5.058A4.972 4.972 0 0 0 7.143.238 4.871 4.871 0 0 0 2.1 4.864v1.717a1.321 1.321 0 0 1-.387.935L.2 9.306a.662.662 0 0 0 .468 1.129h12.67a.661.661 0 0 0 .467-1.129ZM4.45 11.781A2.453 2.453 0 0 0 7 13.764a2.454 2.454 0 0 0 2.551-1.983Z" />
  </svg>
);

export default SvgComponent;
